import React, { Suspense } from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';

const OAuthConsentView = React.lazy(() => import('views/oauth-consent'));
const ClientReportView = React.lazy(() => import('views/client-report/ClientReportView'));

const Routes = () => {

	return (
		<RouterRoutes>
			{/*
			 * OAuth consent page — opened in a fresh browser by the OAuth client
			 * (Claude Desktop). It must not be wrapped by ProtectedRoute (which
			 * would lose the OAuth query params on login redirect) or by
			 * PublicRoute (which would bounce already-logged-in users away from
			 * the consent screen). The page handles auth itself.
			 */}
			<Route
				path="/oauth/consent"
				element={
					<Suspense fallback={null}>
						<OAuthConsentView />
					</Suspense>
				}
			/>
			{/* Public client report — no login, reached by token (spec §8). Standalone,
			    like the OAuth page: not wrapped by Protected/PublicRoute. */}
			<Route
				path="/r/:token"
				element={
					<Suspense fallback={null}>
						<ClientReportView />
					</Suspense>
				}
			/>
			<Route path="/" element={<ProtectedRoute />}>
				<Route path="/" element={<Navigate replace to={AUTHENTICATED_ENTRY} />} />
				{protectedRoutes.map((route, index) => {
					return (
						<Route 
							key={route.key + index} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
				<Route path="*" element={<Navigate to="/" replace />} />
			</Route>
			<Route path="/" element={<PublicRoute />}>
				{publicRoutes.map(route => {
					return (
						<Route 
							key={route.path} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/ >
					)
				})}
			</Route>
		</RouterRoutes>
	)
}

export default Routes